export default [
  {
    path: '/premium-offer/add',
    name: 'create-premium-offer',
    component: () => import('@/views/premium-offer/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Update Premium Offer',
      requiresFeature: 'enableSubscriptions',
      parent: 'PremiumOfferList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Premium Offer', url: '/premium-offer/add' },
        { title: 'Update Premium Offer', active: true }
      ]
    }
  }
]
